import React, { useEffect, useState } from "react";
import { FaPen, FaPlus } from "react-icons/fa6";
import { NavLink, useOutletContext } from "react-router-dom";
import {
  detectOpenAdmission,
  detectOpenClass,
  extractAdminOverview,
  showSwal,
  updateAllClassAdmission,
  updateAllCurrentClass,
} from "../../AppManager";
import ConfirmAction from "../../components/ConfirmAction";

function OverviewGeneral() {
  const { centres, record, currUser, setRecord, maxStudents } =
    useOutletContext();
  const [overview, setOverview] = useState({
    centre: 0,
    classes: 0,
    teacher: 0,
    assistant: 0,
    students: 0,
  });
  const [admissions, setAdmissions] = useState(false);
  const [classes, setClasses] = useState(false);
  const [close, setClose] = useState(true);
  const [actionEvent, setActionEvent] = useState({});

  document.title = "Overview";

  function toggleReg(e) {
    const { name, type, value } = e.target;
    setActionEvent({ name, type, value });
    setClose("admission");
  }

  function toggleClasses(e) {
    const { name, type, value } = e.target;
    setActionEvent({ name, type, value });
    setClose("class");
  }

  async function toggleClassAdmission({ name, type, value }) {
    if (name === "regclose" && type === "button") {
      const status = value === "OPEN";
      const res = await updateAllClassAdmission();
      if (res === "Updated") {
        setRecord((oldRecord) => {
          const newRecord = oldRecord;
          for (const centre in newRecord) {
            if (Object.hasOwnProperty.call(newRecord, centre)) {
              const centreData = newRecord[centre];
              for (const trainingClass in centreData) {
                if (Object.hasOwnProperty.call(centreData, trainingClass)) {
                  const classData = centreData[trainingClass].classes;
                  for (let i = 0; i < classData.length; i++) {
                    const Class = classData[i];
                    Class.admission = status;
                  }
                }
              }
            }
          }
          return newRecord;
        });
        showSwal(
          !admissions ? "success" : "info",
          `Admission ${!admissions ? "Opened" : "Closed"}`
        );
        setAdmissions((old) => !old);
      } else {
        showSwal("error", "Failed");
      }
    }
  }

  async function toggleCurrentClass({ name, type, value }) {
    if (name === "classclose" && type === "button") {
      const status = value === "OPEN";
      const res = await updateAllCurrentClass();
      if (res === "Updated") {
        setRecord((oldRecord) => {
          const newRecord = oldRecord;
          for (const centre in newRecord) {
            if (Object.hasOwnProperty.call(newRecord, centre)) {
              const centreData = newRecord[centre];
              for (const trainingClass in centreData) {
                if (Object.hasOwnProperty.call(centreData, trainingClass)) {
                  const classData = centreData[trainingClass].classes;
                  for (let i = 0; i < classData.length; i++) {
                    const Class = classData[i];
                    Class.currentClass = status;
                  }
                }
              }
            }
          }
          return newRecord;
        });
        showSwal(
          !classes ? "success" : "info",
          `Classes ${!classes ? "Started" : "Closed"}`
        );
        setClasses((old) => old);
      } else {
        showSwal("error", "Failed");
      }
    }
  }

  useEffect(() => {
    setOverview(extractAdminOverview(record));

    if (detectOpenAdmission(record)) {
      setAdmissions(true);
    }

    if (detectOpenClass(record)) {
      setClasses(true);
    }
  }, [record]);

  return (
    <div className="overview-class admin-overview-class">
      {close !== true && (
        <ConfirmAction
          currUser={currUser}
          setClose={setClose}
          confirmed={() => {
            close === "admission"
              ? toggleClassAdmission(actionEvent)
              : toggleCurrentClass(actionEvent);
          }}
        />
      )}
      <h1 className="heading1">General Overview</h1>
      <div>
        <div>
          <h1 className="heading3" style={{ textAlign: "left" }}>
            Number of Centres:
          </h1>
          <span>
            <NavLink to="/admin/overview/centres">{centres.length}</NavLink>
            <NavLink to="/admin/overview/addcentre">
              <FaPlus />
            </NavLink>
          </span>
        </div>
        <div>
          <h1 className="heading3" style={{ textAlign: "left" }}>
            Number of Classes:
          </h1>
          <span>
            <NavLink to="/admin/overview/classes">{overview.classes}</NavLink>
            <NavLink to="/admin/overview/addclass">
              <FaPlus />
            </NavLink>
            <NavLink to="/admin/overview/editclass">
              <FaPen />
            </NavLink>
          </span>
        </div>
        <div>
          <h1 className="heading3" style={{ textAlign: "left" }}>
            Number of Teachers:
          </h1>
          <span>
            <NavLink to="/admin/overview/teachers/analysis">
              {overview.teacher + overview["assistant"]}
            </NavLink>
            <NavLink to="/admin/overview/addteacher">
              <FaPlus />
            </NavLink>
          </span>
        </div>
        <div>
          <h1 className="heading3" style={{ textAlign: "left" }}>
            Number of Students:
          </h1>
          <span>
            <NavLink to="/admin/overview/students/analysis">
              {overview.students}
            </NavLink>
          </span>
        </div>
        <div>
          <h1 className="heading3" style={{ textAlign: "left" }}>
            Max Number of Students:
          </h1>
          <span>
            {maxStudents}
            <NavLink to="/admin/studentsmax">
              <FaPen />
            </NavLink>
          </span>
        </div>
        <div>
          <h1 className="heading3" style={{ textAlign: "left" }}>
            Passing Marks for Classes
          </h1>
          <span>
            <NavLink to="/admin/marks">View</NavLink>
          </span>
        </div>
        <div>
          <h1 className="heading3" style={{ textAlign: "left" }}>
            Admission Status:
          </h1>
          <span className="checkbox-wrapper">
            <button
              type="button"
              className="text-btn sp-btn"
              name="regclose"
              style={{
                fontSize: "1em",
                fontWeight: "bolder",
                backgroundColor: !admissions ? "green" : "rgb(195, 6, 6)",
                border: "none",
              }}
              onClick={toggleReg}
              value={!admissions ? "OPEN" : "CLOSE"}
            >
              {!admissions ? "OPEN" : "CLOSE"}
            </button>
            <p
              style={{
                color: admissions ? "green" : "rgb(195, 6, 6)",
              }}
            >
              Currently {admissions ? "Open" : "Closed"}
            </p>
          </span>
        </div>
        <div>
          <h1 className="heading3" style={{ textAlign: "left" }}>
            Classes Status:
          </h1>
          <span className="checkbox-wrapper">
            <button
              type="button"
              className="text-btn sp-btn"
              name="classclose"
              style={{
                fontSize: "1em",
                fontWeight: "bolder",
                backgroundColor: !classes ? "green" : "rgb(195, 6, 6)",
                border: "none",
              }}
              onClick={toggleClasses}
              value={!classes ? "START" : "CLOSE"}
            >
              {!classes ? "START" : "CLOSE"}
            </button>
            <p
              style={{
                color: classes ? "green" : "rgb(195, 6, 6)",
              }}
            >
              Currently {classes ? "Ongoing" : "Closed"}
            </p>
          </span>
        </div>
      </div>
    </div>
  );
}

export default OverviewGeneral;
